/**
 * 
 * Only for Preview component to show one side pages
 * 
 */

fx.ns("shared.stage", class StageSingle extends shared.stage.Stage
{
	constructor(page, model, componentFactory, side)
	{
		super(page, model, componentFactory, side);
	}

	/******************* Getters *******************/

	get book()
	{
		return this._model.creation;
	}
	
	/********************* Overrides **********************/

	position()
	{
		if (this.displayedSide == 'left')
		{
			this._realPosition = {top:0, left:0};
		}
		else
		{
			if (this.data.typeid == 6) // Cover
				this._realPosition = {top:0, right:this.book.sliceWidth, left:"auto"}
			else
				this._realPosition = {top:0, right:0};
		}
		this.css(this._realPosition);
	}

	addComponent(element, init)
	{
		let boundingRect = fx.graphics.getBoundingRect(element, element.rotation);

		// remove the invisible part of the double page
		if (element.creation == "slice")
			return;
/*
		// remove elements for backcovers
		if (this.data.hasbackcover)
		{
			if (this.displayedSide == "left" && this.data.isFirstPage)
				return;
			
			if (this.displayedSide == "right" && this.data.isLastPage)
				return;
		}

		// remove empty photos
		if (element.isPhoto)
		{
			if (!this.model.photos.find({ id : element.content }))
				return;
		}
		else
		if (element.isText && element.content == "")
			return;
		*/	
		
		// remove elements for adjacent side
		if (this.displayedSide == "left")
		{
			if (element.component_type == "background") // element background doesn't have width and height
			{
				if (element.creation == "right")
					return;
			}
			else
			{
				//if (element.x > this.book.pageWidth)
				if ( boundingRect.x > this.book.pageWidth)
					return;
			}
		}

		if (this.displayedSide == "right")
		{
			if (element.component_type == "background")
			{
				if (element.creation == "left")
					return;
			}
			else
			{
				if (this.data.typeid == 6 && element.x + element.width <= this.book.pageWidth + this.book.sliceWidth)
					return;
	
				//if (element.x + element.width < this.book.pageWidth)
				if ( boundingRect.x + boundingRect.width < this.book.pageWidth)
					return;
			}
			
		}

		// add the visible part of the double page
		let component = this._factory.create(element, this.model, this, !init);
		if (component)
		{
			// component.single = false; // to show backgroud shadow for Preview single stage
			component.single = this.single;

			this.addChild( component );

			if (!init)
			{
				this.trigger("component-added", {component : component});
			}
		}

		///----------------- Hide components not needed
		let showComponent = true;
		// remove elements for backcovers
		if (this.data.hasbackcover)
		{
			if (this.displayedSide == "left" && this.data.isFirstPage)
				showComponent = false;
			
			if (this.displayedSide == "right" && this.data.isLastPage)
				showComponent = false;
		}

		// remove empty photos
		if (element.isPhoto)
		{
			if (!this.model.photos.find({ id : element.content }))
				showComponent = false;
		}
		else
		if (element.isText && element.content == "")
			showComponent = false;

		if (!showComponent)
			component.hide();

		///-----------------

		return component;
	}

});